import {
  ADD_TRAINING_FAIL,
  ADD_TRAINING_REQUEST,
  ADD_TRAINING_SUCCESS,
  GET_TRAINING_FAIL,
  GET_TRAINING_REQUEST,
  GET_TRAINING_SUCCESS,
  DELETE_TRAINING_FAIL,
  DELETE_TRAINING_REQUEST,
  DELETE_TRAINING_SUCCESS,
  GET_SPECIFIC_TRAINING_REQUEST,
  GET_SPECIFIC_TRAINING_SUCCESS,
  GET_SPECIFIC_TRAINING_FAIL,
  ADD_DEPARTMENT_IN_TRAINING_FAIL,
  ADD_DEPARTMENT_IN_TRAINING_REQUEST,
  ADD_DEPARTMENT_IN_TRAINING_SUCCESS,
  ADD_USER_IN_TRAINING_FAIL,
  ADD_USER_IN_TRAINING_REQUEST,
  ADD_USER_IN_TRAINING_SUCCESS,
  ADD_MODULE_IN_TRAINING_FAIL,
  ADD_MODULE_IN_TRAINING_REQUEST,
  ADD_MODULE_IN_TRAINING_SUCCESS,
  ADD_QUIZ_IN_TRAINING_FAIL,
  ADD_QUIZ_IN_TRAINING_REQUEST,
  ADD_QUIZ_IN_TRAINING_SUCCESS,
  ADD_SECTION_IN_TRAINING_FAIL,
  ADD_SECTION_IN_TRAINING_REQUEST,
  ADD_SECTION_IN_TRAINING_SUCCESS,
  EDIT_QUIZ_IN_TRAINING_FAIL,
  EDIT_QUIZ_IN_TRAINING_REQUEST,
  EDIT_QUIZ_IN_TRAINING_SUCCESS,
  UPDATE_QUIZ_NAME_IN_TRAINING_FAIL,
  UPDATE_QUIZ_NAME_IN_TRAINING_REQUEST,
  UPDATE_QUIZ_NAME_IN_TRAINING_SUCCESS,
} from "../../types/admin/trainingTypes";

export const addTrainingReducer = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case ADD_TRAINING_REQUEST:
      return {
        ...state,
        addTrainingLoading: true,
      };
    case ADD_TRAINING_SUCCESS:
      return {
        ...state,
        addTrainingLoading: false,
        addTrainingInfo: payload,
        addTrainingError: "",
      };
    case ADD_TRAINING_FAIL:
      return {
        ...state,
        addTrainingLoading: false,
        addTrainingInfo: [],
        addTrainingError: payload,
      };
    default:
      return state;
  }
};

export const addUsersInTrainingReducer = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case ADD_USER_IN_TRAINING_REQUEST:
      return {
        ...state,
        addUserInTrainingLoading: true,
      };
    case ADD_USER_IN_TRAINING_SUCCESS:
      return {
        ...state,
        addUserInTrainingLoading: false,
        addUserInTrainingInfo: payload,
        addUserInTrainingError: "",
      };
    case ADD_USER_IN_TRAINING_FAIL:
      return {
        ...state,
        addUserInTrainingLoading: false,
        addUserInTrainingInfo: [],
        addUserInTrainingError: payload,
      };
    default:
      return state;
  }
};

export const addDepartInTrainingReducer = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case ADD_DEPARTMENT_IN_TRAINING_REQUEST:
      return {
        ...state,
        addDepartInTrainingLoading: true,
      };
    case ADD_DEPARTMENT_IN_TRAINING_SUCCESS:
      return {
        ...state,
        addDepartInTrainingLoading: false,
        addDepartInTrainingInfo: payload,
        addDepartInTrainingError: "",
      };
    case ADD_DEPARTMENT_IN_TRAINING_FAIL:
      return {
        ...state,
        addDepartInTrainingLoading: false,
        addDepartInTrainingInfo: [],
        addDepartInTrainingError: payload,
      };
    default:
      return state;
  }
};

export const addModuleInTrainingReducer = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case ADD_MODULE_IN_TRAINING_REQUEST:
      return {
        ...state,
        addModuleInTrainingLoading: true,
      };
    case ADD_MODULE_IN_TRAINING_SUCCESS:
      return {
        ...state,
        addModuleInTrainingLoading: false,
        addModuleInTrainingInfo: payload,
        addModuleInTrainingError: "",
      };
    case ADD_MODULE_IN_TRAINING_FAIL:
      return {
        ...state,
        addModuleInTrainingLoading: false,
        addModuleInTrainingInfo: [],
        addModuleInTrainingError: payload,
      };
    default:
      return state;
  }
};

export const addQuizInTrainingReducer = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case ADD_QUIZ_IN_TRAINING_REQUEST:
      return {
        ...state,
        addQuizInTrainingLoading: true,
      };
    case ADD_QUIZ_IN_TRAINING_SUCCESS:
      return {
        ...state,
        addQuizInTrainingLoading: false,
        addQuizInTrainingInfo: payload,
        addQuizInTrainingError: "",
      };
    case ADD_QUIZ_IN_TRAINING_FAIL:
      return {
        ...state,
        addQuizInTrainingLoading: false,
        addQuizInTrainingInfo: [],
        addQuizInTrainingError: payload,
      };
    default:
      return state;
  }
};

export const editQuizInTrainingReducer = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case EDIT_QUIZ_IN_TRAINING_REQUEST:
      return {
        ...state,
        editQuizInTrainingLoading: true,
      };
    case EDIT_QUIZ_IN_TRAINING_SUCCESS:
      return {
        ...state,
        editQuizInTrainingLoading: false,
        editQuizInTrainingInfo: payload,
        editQuizInTrainingError: "",
      };
    case EDIT_QUIZ_IN_TRAINING_FAIL:
      return {
        ...state,
        editQuizInTrainingLoading: false,
        editQuizInTrainingInfo: [],
        editQuizInTrainingError: payload,
      };
    default:
      return state;
  }
};

export const editQuizNameInTrainingReducer = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case UPDATE_QUIZ_NAME_IN_TRAINING_REQUEST:
      return {
        ...state,
        editQuizNameInTrainingLoading: true,
      };
    case UPDATE_QUIZ_NAME_IN_TRAINING_SUCCESS:
      return {
        ...state,
        editQuizNameInTrainingLoading: false,
        editQuizNameTrainingInfo: payload,
        editQuizNameTrainingError: "",
      };
    case UPDATE_QUIZ_NAME_IN_TRAINING_FAIL:
      return {
        ...state,
        editQuizNameInTrainingLoading: false,
        editQuizNameTrainingInfo: [],
        editQuizNameTrainingError: payload,
      };
    default:
      return state;
  }
};

export const addSectionInTrainingReducer = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case ADD_SECTION_IN_TRAINING_REQUEST:
      return {
        ...state,
        addSectionInTrainingLoading: true,
      };
    case ADD_SECTION_IN_TRAINING_SUCCESS:
      return {
        ...state,
        addSectionInTrainingLoading: false,
        addSectionInTrainingInfo: payload,
        addSectionInTrainingError: "",
      };
    case ADD_SECTION_IN_TRAINING_FAIL:
      return {
        ...state,
        addSectionInTrainingLoading: false,
        addSectionInTrainingInfo: [],
        addSectionInTrainingError: payload,
      };
    default:
      return state;
  }
};

export const getTrainingReducer = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case GET_TRAINING_REQUEST:
      return {
        ...state,
        getTrainingLoading: true,
      };
    case GET_TRAINING_SUCCESS:
      return {
        ...state,
        getTrainingLoading: false,
        getTrainingInfo: payload,
        getTrainingError: "",
      };
    case GET_TRAINING_FAIL:
      return {
        ...state,
        getTrainingLoading: false,
        getTrainingInfo: [],
        getTrainingError: payload,
      };
    default:
      return state;
  }
};

export const deleteTrainingReducer = (state = {}, action) => { 
  const { type, payload } = action;
  switch (type) {
    case DELETE_TRAINING_REQUEST:
      return {
        ...state,
        deleteTrainingLoading: true,
      };
    case DELETE_TRAINING_SUCCESS:
      return {
        ...state,
        deleteTrainingLoading: false,
        deleteTrainingInfo: payload,
        deleteTrainingError: "",
      };
    case DELETE_TRAINING_FAIL:
      return {
        ...state,
        deleteTrainingLoading: false,
        deleteTrainingInfo: [],
        deleteTrainingError: payload,
      };
    default:
      return state;
  }
}

export const getSpecificTrainingReducer = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case GET_SPECIFIC_TRAINING_REQUEST:
      return {
        ...state,
        getSpecificTrainingLoading: true,
      };
    case GET_SPECIFIC_TRAINING_SUCCESS:
      return {
        ...state,
        getSpecificTrainingLoading: false,
        getSpecificTrainingInfo: payload,
        getSpecificTrainingError: "",
      };
    case GET_SPECIFIC_TRAINING_FAIL:
      return {
        ...state,
        getSpecificTrainingLoading: false,
        getSpecificTrainingInfo: [],
        getSpecificTrainingError: payload,
      };
    default:
      return state;
  }
}